import store from "../core/redux/store";

export const getMessage = (messageKey?: string, defaultMessage?: string): string => {
  if (messageKey) {
    // The ResponseMessage schema lowercases messageKey on write, but backend controllers
    // send the literal (often camelCase) key as-is — normalize here so overrides for keys
    // like "auth.checkAvailability.failed" still match the stored "auth.checkavailability.failed".
    const custom = store.getState().messages.map[messageKey.toLowerCase()];
    if (custom) return custom;
  }
  return defaultMessage || "Something went wrong.";
};
